module.exports = __webpack_public_path__ + "img/bv.89aa8b26.svg";